import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useState } from 'react';
const TYPEWRITER_INTERVAL_MS = 25;
const VISIBLE_DURATION_MS = 3000;
const FADE_DURATION_MS = 500;
export const useAnimatedPlaceholder = (param)=>{
    let { disabled, value, suggestions } = param;
    const [placeholderState, setPlaceholderState] = useState({
        currentSuggestionIndex: 0,
        displayedText: '',
        isTyping: true,
        opacity: 1
    });
    useEffect(()=>{
        if (disabled || value || suggestions.length === 0) {
            setPlaceholderState({
                currentSuggestionIndex: 0,
                displayedText: '',
                isTyping: false,
                opacity: 0
            });
            return;
        }
        let timeoutId;
        let typingTimeoutId;
        let fadeTimeoutId;
        const currentSuggestion = suggestions[placeholderState.currentSuggestionIndex];
        let charIndex = 0;
        const typeNextChar = ()=>{
            if (charIndex < currentSuggestion.length) {
                setPlaceholderState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        displayedText: currentSuggestion.slice(0, charIndex + 1)
                    }));
                charIndex++;
                typingTimeoutId = setTimeout(typeNextChar, TYPEWRITER_INTERVAL_MS);
            } else {
                setPlaceholderState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        isTyping: false
                    }));
                timeoutId = setTimeout(()=>{
                    setPlaceholderState((prev)=>_object_spread_props(_object_spread({}, prev), {
                            opacity: 0
                        }));
                    fadeTimeoutId = setTimeout(()=>{
                        setPlaceholderState((prev)=>({
                                currentSuggestionIndex: (prev.currentSuggestionIndex + 1) % suggestions.length,
                                displayedText: '',
                                isTyping: true,
                                opacity: 1
                            }));
                    }, FADE_DURATION_MS);
                }, VISIBLE_DURATION_MS);
            }
        };
        setPlaceholderState((prev)=>_object_spread_props(_object_spread({}, prev), {
                opacity: 1,
                isTyping: true,
                displayedText: ''
            }));
        typeNextChar();
        return ()=>{
            clearTimeout(timeoutId);
            clearTimeout(typingTimeoutId);
            clearTimeout(fadeTimeoutId);
        };
    }, [
        disabled,
        value,
        placeholderState.currentSuggestionIndex,
        suggestions
    ]);
    return {
        displayedText: placeholderState.displayedText,
        isTyping: placeholderState.isTyping,
        opacity: placeholderState.opacity,
        duration: FADE_DURATION_MS / 1000
    };
};
